import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-regenerate-item-modal',
  templateUrl: './regenerate-item-modal.component.html',
  styleUrl: './regenerate-item-modal.component.scss',
})
export class RegenerateItemModalComponent {
  @Input() remainingItems: any[] = [];

  allSelected = false;
  selectedCount = 0;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {
    this.updateSelectionState();
  }

  toggleSelectAll() {
    this.allSelected = !this.allSelected;
    this.remainingItems.forEach((item) => {
      item.selected = this.allSelected;
    });
    this.updateSelectionState();
  }

  toggleItem(item: any) {
    item.selected = !item.selected;
    this.updateSelectionState();
  }

  onItemSelectionChange() {
    this.updateSelectionState();
  }

  updateSelectionState() {
    this.selectedCount = this.remainingItems.filter(
      (item) => item.selected
    ).length;
    this.allSelected =
      this.remainingItems.length > 0 &&
      this.selectedCount === this.remainingItems.length;
  }

  dismiss() {
    this.activeModal.dismiss();
  }

  confirm() {
    const selectedItems = this.remainingItems.filter((item) => item.selected);
    this.activeModal.close({
      selectedItems: selectedItems,
      needEnquiry: true,
    });
  }

  skip() {
    this.activeModal.close({
      selectedItems: [],
      needEnquiry: false,
    });
  }
}
